require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./down-with-the-sickness.json") })
        }
      }, "path---down-with-the-sickness");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---down-with-the-sickness!./.cache/json/down-with-the-sickness.json
// module id = 510
// module chunks = 231608221292675